import { css } from "@emotion/react";
import { useTheme } from "@mui/material";

import {
  AnswerRow,
  CreatedAtDetailRow,
  UserDetailRow,
} from "~/components/item/[id]/ItemRow";
import { ResponseContentProps } from "~/components/item/[id]/response-content/lib";
import { sortedQuestionAnswerPairs } from "~/components/item/page/[id]/lib";
import { formatDateTime } from "~/lib/graphql/graphqlClient";
import { useAppContext } from "~/pages/_app";

const ResponseContent = ({ questions, response }: ResponseContentProps) => {
  const { currentUser } = useAppContext();
  const answerQuestionPairs = sortedQuestionAnswerPairs(response, questions);
  const theme = useTheme();
  return (
    <div css={rootStyle}>
      {answerQuestionPairs.map(([question, answer], index) => (
        <AnswerRow
          key={index}
          answer={answer}
          question={question}
          isOwner={currentUser?.id === response.user.id}
        />
      ))}
      <div
        css={css`
          width: 100%;
          border-top: 1px solid ${theme.palette.divider};
          margin-top: 4rem;
          margin-bottom: 1rem;
        `}
      />
      <UserDetailRow name={response.user.name} />
      <CreatedAtDetailRow createdAt={formatDateTime(response.createdAt)} />
    </div>
  );
};

const rootStyle = css`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
`;

export default ResponseContent;
